export class PagerBaseData {
  currentPage: number;
  startPage: number;
  endPage: number;
  pages: Array<number>;
  totalPages: number;
}
